import { render, staticRenderFns } from "./SiteNavItem.vue?vue&type=template&id=517bdb0c"
import script from "./SiteNavItem.vue?vue&type=script&lang=js"
export * from "./SiteNavItem.vue?vue&type=script&lang=js"
import style0 from "./SiteNavItem.vue?vue&type=style&index=0&id=517bdb0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports